import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/storage'

// export function initApp() {
    var config = {
        apiKey: "AIzaSyAW5uP2e6KxkTY8oBrZWvGCd6gy73p3-Sw",
        authDomain: "naij-news.firebaseapp.com",
        databaseURL: "https://naij-news.firebaseio.com",
        projectId: "naij-news",
        storageBucket: "naij-news.appspot.com",
        messagingSenderId: "835936985560"
    };

    // if (!firebase.apps.length) {
    //     firebase.initializeApp(config);
    // }
// }

export const firebaseInit = firebase.initializeApp(config)

//Initialize cloud firestore through firebase
export const db = firebase.firestore();

//Initialize cloud storage through friebase
export const storage = firebase.storage()

//Disable deprecated features
// db.settings({
//     timestampsInSnapshots: true
// })


// WEBPACK FOOTER //
// ./src/resources/firebase.js